import API from '.';

export default class Location {
  constructor({
    locationName,
    locationStreetAddress1,
    locationStreetAddress2,
    country,
    countrySubdivision,
    locationCity,
    locationPostalCode,
    locationCounty,
    latitude,
    longitude,
    timezone,
    locationDesc,
    realEstateInterestList,
    primaryUseType,
    affiliateOwnershipPercentage,
    jVOwnershipPercentage,
    locationOperationStatus,
    storeBrand,
    fuelBrand,
    stewardshipCostObjectList,
    sourceSystemLinkList,
    businessLineAllocationList,
    epsBusinessLineAllocationList,
    siteId,
    siteName,
    siteCode,
    siteOperationStatus,
    siteOperationStatusId,
    sitePrimaryUseTypeId,
    itSiteCodeList,
    siteSourceLinkList,
    buildingList,
    destinationSystem,
    reProcessConexxion,
  }) {
    this.locationName = locationName;
    this.locationStreetAddress1 = locationStreetAddress1;
    this.locationStreetAddress2 = locationStreetAddress2;
    this.country = country;
    this.countrySubdivision = countrySubdivision;
    this.locationCity = locationCity;
    this.locationPostalCode = locationPostalCode;
    this.locationCounty = locationCounty;
    this.latitude = latitude;
    this.longitude = longitude;
    this.timezone = timezone;
    this.locationDesc = locationDesc;
    this.realEstateInterestList = realEstateInterestList;
    this.primaryUseType = primaryUseType;
    this.affiliateOwnershipPercentage = affiliateOwnershipPercentage;
    this.jVOwnershipPercentage = jVOwnershipPercentage;
    this.locationOperationStatus = locationOperationStatus;
    this.storeBrand = storeBrand;
    this.fuelBrand = fuelBrand;
    this.stewardshipCostObjectList = stewardshipCostObjectList;
    this.sourceSystemLinkList = sourceSystemLinkList;
    this.businessLineAllocationList = businessLineAllocationList;
    this.epsBusinessLineAllocationList = epsBusinessLineAllocationList;
    this.siteId = siteId;
    this.siteName = siteName;
    this.siteCode = siteCode;
    this.siteOperationStatus = siteOperationStatus;
    this.siteOperationStatusId = siteOperationStatusId;
    this.sitePrimaryUseTypeId = sitePrimaryUseTypeId;
    this.itSiteCodeList = itSiteCodeList;
    this.siteSourceLinkList = siteSourceLinkList;
    this.buildingList = buildingList;
    this.destinationSystem = destinationSystem;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/location');
    return data.map((d) => new Location(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`location/${id}`);
    return data.map((d) => new Location(d));
  }

  static async create(data) {
    const api = await API();
    const newLocationData = new Location(data);
    const newLocationFormatted = {
      LocationName: newLocationData.locationName,
      LocationDesc: newLocationData.locationDesc,
      LocationStreetAddress1: newLocationData.locationStreetAddress1,
      LocationStreetAddress2: newLocationData.locationStreetAddress2,
      LocationCity: newLocationData.locationCity,
      LocationPostalCode: newLocationData.locationPostalCode,
      CountrySubdivisionId: newLocationData.countrySubdivision.id,
      CountryId: newLocationData.country.id,
      LocationCounty: newLocationData.locationCounty,
      LocationLat: newLocationData.latitude,
      LocationLong: newLocationData.longitude,
      TimezoneId: newLocationData.timezone.timezoneId,
      PrimaryUseTypeId: newLocationData.primaryUseType.id,
      OperationStatusId: newLocationData.locationOperationStatus.id,
      StoreBrandId: newLocationData.storeBrand.id,
      FuelBrandId: newLocationData.fuelBrand.id,
      AffiliateOwnershipPercentage: newLocationData.affiliateOwnershipPercentage,
      JVOwnershipPercentage: newLocationData.jVOwnershipPercentage,
      DestinationSystem: newLocationData.destinationSystem,

      RealEstateInterest: newLocationData.realEstateInterestList.map(
        (realEstateInterest) => {
          return {
            realEstateInterestId: realEstateInterest.realEstateInterestId
              ? realEstateInterest.realEstateInterestId : 0,
            realEstateInterestTypeId: realEstateInterest.realEstateInterestTypeId,
            realEstateInterestName: realEstateInterest.realEstateInterestName,
            realEstateInterestDesc: realEstateInterest.realEstateInterestDesc,
            realEstateInterestArea: realEstateInterest.realEstateInterestArea,
            realEstateInterestSizeUOM: realEstateInterest.realEstateInterestSizeUOM,
            isPrimaryRealEstateInterest: realEstateInterest.primary ? 1 : 0,
            realEstateInterestSourceSystemRelateData:
              realEstateInterest.realEstateInterestSourceSystemRelate.map(
                (reiSourceSystem) => {
                  return {
                    reiSourceSystemRelateId: reiSourceSystem.reiSourceSystemRelateId
                      ? reiSourceSystem.reiSourceSystemRelateId : 0,
                    realEstateInterestId: reiSourceSystem.realEstateInterestId
                      ? reiSourceSystem.realEstateInterestId : 0,
                    sourceSystemId: reiSourceSystem.realEstateInterestSourceSystemId,
                    sourceSystemIdTypeId:
                      reiSourceSystem.realEstateInterestSourceSystemTypeId,
                    sourceSystemReferenceId:
                      reiSourceSystem.realEstateInterestSourceSystemReferenceID,
                  };
                }
              ),
          };
        }
      ),

      LocationStewardCostObject: newLocationData.stewardshipCostObjectList.map(
        (stewardCostObject) => {
          return {
            CostObjectTypeId: stewardCostObject.costObjectTypeId,
            StewardshipTypeId: stewardCostObject.stewardshipTypeId,
            CostObject: stewardCostObject.costObject,
          };
        }
      ),
      LocationSourceSystemRelate: newLocationData.sourceSystemLinkList.map(
        (sourceSystemLink) => {
          return {
            SourceSystemIdTypeId: sourceSystemLink.sourceSystemIdTypeId,
            SourceSystemReferenceId: sourceSystemLink.sourceSystemReferenceId,
          };
        }
      ),
      LocationBusinessLineRelate: newLocationData.businessLineAllocationList.map(
        (businessLineAllocation) => {
          return {
            business_line_code: businessLineAllocation.businessLineCode,
            company_code: businessLineAllocation.businessLineReportUnitCompanyCode,
            AllocationPercent: businessLineAllocation.allocationPercent,
          };
        }
      ),
      LocationEPSBusinessLineRelate: newLocationData.epsBusinessLineAllocationList.map(
        (epsBusinessLineAllocation) => {
          return {
            eps_business_vc_id: epsBusinessLineAllocation.eps_business_vc_id,
            eps_business_line_id: epsBusinessLineAllocation.eps_business_line_id,
            AllocationPercent: epsBusinessLineAllocation.epsAllocationPercent,
          };
        }
      ),
      Site: {
        SiteId: newLocationData.siteId,
        SiteCode: newLocationData.siteCode,
        CountryId: newLocationData.country.id,
        SiteName: newLocationData.siteName,
        OperationStatusId: newLocationData.siteOperationStatusId,
        PrimaryUseTypeId: newLocationData.sitePrimaryUseTypeId,
        ItSiteCodeRelate: newLocationData.itSiteCodeList.map((itsitecode) => {
          return {
            ITSiteCodeId: itsitecode.itSiteCodeId,
            SiteId: itsitecode.SiteId,
          };
        }),

        SiteSourceSystemRelate: newLocationData.siteSourceLinkList.map(
          (sitesourcelink) => {
            return {
              SiteSourceSystemId: sitesourcelink.siteSourceSystemId,
              SiteId: newLocationData.siteId,
              SourceSystemIdTypeId: sitesourcelink.sourceSystemIdTypeId,
              SourceSystemId: sitesourcelink.sourceSystemId,
              SourceSystemReferenceId: sitesourcelink.sourceSystemReferenceId,
            };
          }
        ),
      },
      SiteId: newLocationData.siteId,
      Building: newLocationData.buildingList.filter(b => b.buildingName.trim() !== "" || b.buildingDesc.trim() !== "").map(
        (building) => {
          return {
            BuildingId: building.buildingId,
            BuildingName: building.buildingName,
            BuildingDesc: building.buildingDesc,
            BuildingSourceSystemRelate: [{
              SourceSystemReferenceId: building.sourceSystemReferenceId,
              SourceSystemIdTypeId: building.sourceSystemIdTypeId,
              BuildingId: building.buildingId,
            }]
          };
        }
      )
    };
    const res = api.post('location', newLocationFormatted);
    return res;
  }

  static async update(data) {
    const api = await API();
    const updateLocationData = data;
    const newLocationFormatted = {
      LocationId: updateLocationData.locationId,
      LocationName: updateLocationData.locationName,
      LocationDesc: updateLocationData.locationDesc,
      LocationStreetAddress1: updateLocationData.locationStreetAddress1,
      LocationStreetAddress2: updateLocationData.locationStreetAddress2,
      LocationCity: updateLocationData.locationCity,
      LocationPostalCode: updateLocationData.locationPostalCode,
      CountrySubdivisionId: updateLocationData.countrySubdivision.id,
      CountryId: updateLocationData.country.id,
      LocationCounty: updateLocationData.locationCounty,
      LocationLat: updateLocationData.latitude,
      LocationLong: updateLocationData.longitude,
      TimezoneId: updateLocationData.timezone.timezoneId,
      PrimaryUseTypeId: updateLocationData.primaryUseType.id,
      OperationStatusId: updateLocationData.locationOperationStatus.id,
      StoreBrandId: updateLocationData.storeBrand.id,
      FuelBrandId: updateLocationData.fuelBrand.id,
      AffiliateOwnershipPercentage: updateLocationData.affiliateOwnershipPercentage,
      JVOwnershipPercentage: updateLocationData.jVOwnershipPercentage,
      DestinationSystem: updateLocationData.destinationSystem,

      RealEstateInterest: updateLocationData.realEstateInterestList.map(
        (realEstateInterest) => {
          return {
            locationId: realEstateInterest.locationId,
            realEstateInterestId: realEstateInterest.realEstateInterestId,
            realEstateInterestTypeId: realEstateInterest.realEstateInterestTypeId,
            realEstateInterestName: realEstateInterest.realEstateInterestName,
            realEstateInterestDesc: realEstateInterest.realEstateInterestDesc,
            realEstateInterestLatitude: realEstateInterest.realEstateInterestLatitude,
            realEstateInterestLongitude: realEstateInterest.realEstateInterestLongitude,
            realEstateInterestFrontageSize: realEstateInterest.realEstateInterestFrontageSize,
            realEstateInterestDepthSize: realEstateInterest.realEstateInterestDepthSize,
            realEstateInterestArea: realEstateInterest.realEstateInterestArea,
            realEstateInterestSizeUOM: realEstateInterest.realEstateInterestSizeUOM,
            realEstateInterestBusinessLineAlias: realEstateInterest.realEstateInterestBusinessLineAlias,
            isPrimaryRealEstateInterest: realEstateInterest.primary ? 1 : 0,
            realEstateInterestSourceSystemRelateData:
              realEstateInterest.realEstateInterestSourceSystemRelate.map(
                (reiSourceSystem) => {
                  return {
                    reiSourceSystemRelateId: reiSourceSystem.reiSourceSystemRelateId,
                    realEstateInterestId: reiSourceSystem.realEstateInterestId,
                    sourceSystemId: reiSourceSystem.realEstateInterestSourceSystemId,
                    sourceSystemIdTypeId: reiSourceSystem.realEstateInterestSourceSystemTypeId,
                    sourceSystemReferenceId: reiSourceSystem.realEstateInterestSourceSystemReferenceID,
                  };
                }
              ),
          };
        }
      ),

      LocationStewardCostObject: updateLocationData.stewardshipCostObjectList.map(
        (stewardCostObject) => {
          return {
            Id: stewardCostObject.id,
            CostObjectTypeId: stewardCostObject.costObjectTypeId,
            StewardshipTypeId: stewardCostObject.stewardshipTypeId,
            CostObject: stewardCostObject.costObject,
            LocationId: stewardCostObject.locationId,
          };
        }
      ),
      LocationSourceSystemRelate: updateLocationData.sourceSystemLinkList.map(
        (sourceSystemLink) => {
          return {
            LocationSourceSystemId: sourceSystemLink.locationSourceSystemId,
            SourceSystemIdTypeId: sourceSystemLink.sourceSystemIdTypeId,
            SourceSystemReferenceId: sourceSystemLink.sourceSystemReferenceId,
            LocationId: sourceSystemLink.locationId,
          };
        }
      ),
      LocationBusinessLineRelate: updateLocationData.businessLineAllocationList.map(
        (businessLineAllocation) => {
          return {
            businessLineLocationId: businessLineAllocation.businessLineLocationId,
            locationId: businessLineAllocation.locationId,
            business_line_code: businessLineAllocation.businessLineCode,
            company_code: businessLineAllocation.businessLineReportUnitCompanyCode,
            AllocationPercent: businessLineAllocation.allocationPercent,
          };
        }
      ),
      LocationEPSBusinessLineRelate: updateLocationData.epsBusinessLineAllocationList.map(
        (epsBusinessLineAllocation) => {
          return {
            location_eps_bl_relate_id: epsBusinessLineAllocation.location_eps_bl_relate_id,
            locationId: epsBusinessLineAllocation.locationId,
            eps_business_vc_id: epsBusinessLineAllocation.eps_business_vc_id,
            eps_business_line_id: epsBusinessLineAllocation.eps_business_line_id,
            AllocationPercent: epsBusinessLineAllocation.epsAllocationPercent,
          };
        }
      ),
      Site: {
        SiteId: updateLocationData.siteId,
        SiteCode: updateLocationData.siteCode,
        SiteName: updateLocationData.siteName,
        CountryId: updateLocationData.country.id,
        OperationStatusId: updateLocationData.siteOperationStatusId,
        PrimaryUseTypeId: updateLocationData.sitePrimaryUseTypeId,
        ItSiteCodeRelate: updateLocationData.itSiteCodeList.map((itsitecode) => {
          return {
            ITSiteCodeRelateId: itsitecode.itSiteCodeRelateId,
            ITSiteCodeId: itsitecode.itSiteCodeId,
            SiteId: itsitecode.siteId,
          };
        }),

        SiteSourceSystemRelate: updateLocationData.siteSourceLinkList.map(
          (sitesourcelink) => {
            return {
              SiteSourceSystemId: sitesourcelink.siteSourceSystemId,
              SiteId: sitesourcelink.siteId,
              SourceSystemIdTypeId: sitesourcelink.sourceSystemIdTypeId,
              SourceSystemId: sitesourcelink.sourceSystemId,
              SourceSystemReferenceId: sitesourcelink.sourceSystemReferenceId,
            };
          }
        ),
      },
      SiteId: updateLocationData.siteId,
      Building: updateLocationData.buildingList.filter(b => b.buildingName.trim() !== "" || b.buildingDesc.trim() !== "").map(
        (building) => {
          return {
            BuildingId: building.buildingId,
            BuildingName: building.buildingName,
            BuildingDesc: building.buildingDesc,
            LocationId: updateLocationData.locationId,
            BuildingSourceSystemRelate: building.sourceSystemReferenceId ?
              [{
                BuildingSourceSystemId: building.sourceSystemId,
                SourceSystemReferenceId: building.sourceSystemReferenceId,
                SourceSystemIdTypeId: building.sourceSystemIdTypeId,
                BuildingId: building.buildingId,
              }] : []
          };
        }
      )
    };
    const res = await api.put('location', newLocationFormatted);
    return res;
  }

  static async getBySearchText(searchText) {
    const api = await API();
    const { data } = await api.get(`location/search/${searchText}`);
    return data.map((d) => new Location(d));
  }
}
